import store from "../store";

const resolveFlags = (me) => {
  if (me?.role === "global_admin") {
    return {
      enabled: true,
      chat: true,
      analysis: true,
      replacement_cost: true,
    };
  }
  if (!me?.ai_features) {
    return {
      enabled: false,
      chat: false,
      analysis: false,
      replacement_cost: false,
    };
  }
  return {
    enabled: me.ai_features.enabled === true,
    chat: me.ai_features.chat === true,
    analysis: me.ai_features.analysis === true,
    replacement_cost: me.ai_features.replacement_cost === true,
  };
};

export default function aiFeature(featureKey) {
  return async function aiFeatureMiddleware({ next }) {
    if (!store.getters["auth/isAuthenticated"]) {
      return next({ name: "Login" });
    }

    let me = store.getters["profile/me"];
    if (!me) {
      try {
        await store.dispatch("profile/me");
        me = store.getters["profile/me"];
      } catch (error) {
        return next({ name: "Login" });
      }
    }

    const flags = resolveFlags(me);
    const featureAllowed = featureKey ? flags[featureKey] !== false : true;

    if (!flags.enabled || !featureAllowed) {
      return next({ name: "Home" });
    }

    return next();
  };
}
